(function(scope){
class RxCartError extends Error{
 constructor(code,message){super(message||code);this.code=code;}
}
class SunshadorRxCart{
 constructor(fetcher,root='/'){this.fetcher=fetcher;this.root=root;}
 async request(path,options={}){
  const response=await this.fetcher(this.root+path,{credentials:'same-origin',...options});
  const data=await response.json();
  if(!response.ok)throw new RxCartError('cart_error',data.description||data.message);
  return data;
 }
 async read(){return this.request('cart.js',{cache:'no-store'});}
 async post(path,data){return this.request(path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});}
 async clean(config){
  const cart=await this.read();
  const owned=cart.items.filter(i=>i.properties?._rx_config===config);
  const parents=owned.filter(i=>i.properties._rx_role==='frame');
  for(const item of parents.length?parents:owned)await this.post('cart/change.js',{id:item.key,quantity:0});
 }
 complete(cart,config,frameId,lensId,requiresFile=false){
  const items=cart.items.filter(i=>i.properties?._rx_config===config);
  const parent=items.find(i=>Number(i.variant_id)===Number(frameId)&&i.properties._rx_role==='frame');
  const child=items.find(i=>Number(i.variant_id)===Number(lensId)&&i.properties._rx_role==='lens');
  return !!parent&&(!requiresFile||this.hasUploadedFile(parent))&&parent.quantity===1&&(!lensId||(!!child&&child.quantity===1&&child.parent_relationship?.parent_key===parent.key));
 }
 hasUploadedFile(item){
  try{const url=new URL(item.properties?._Prescription_file);return url.protocol==='https:'&&(url.hostname==='cdn.shopify.com'||url.hostname.endsWith('.shopify.com'));}catch{return false;}
 }
 async add({frameId,lensId,properties,file}){
  if(file&&(!['image/jpeg','image/png','application/pdf'].includes(file.type)||file.size>10*1024*1024))throw new RxCartError('upload_error');
  const config=properties._rx_config;
  if(!config)throw new RxCartError('cart_error');
  const before=await this.read();
  if(before.items.some(i=>i.properties?._rx_config===config))throw new RxCartError('cart_error');
  try{
   const data=new FormData();data.set('id',String(frameId));data.set('quantity','1');
   for(const [name,value]of Object.entries(properties))data.set('properties['+name+']',String(value));
   if(file)data.set('properties[_Prescription_file]',file,file.name);
   const parent=await this.request('cart/add.js',{method:'POST',body:data});
   if(!parent.key||parent.quantity!==1||(file&&!this.hasUploadedFile(parent)))throw new RxCartError('cart_error');
   if(lensId)await this.post('cart/add.js',{items:[{id:Number(lensId),quantity:1,parent_line_key:parent.key,properties:{_rx_config:config,_rx_role:'lens',Frame:properties.Frame||String(frameId)}}]});
   const cart=await this.read();
   if(!this.complete(cart,config,frameId,lensId,!!file))throw new RxCartError('cart_error');
   return cart;
  }catch(error){
   try{
    const cart=await this.read();
    if(this.complete(cart,config,frameId,lensId,!!file))return cart;
    await this.clean(config);
   }catch{}
   throw error;
  }
 }
}
scope.SunshadorRxCart=SunshadorRxCart;
if(typeof module!=='undefined')module.exports={SunshadorRxCart,RxCartError};
})(typeof window==='undefined'?globalThis:window);

